export const INTEGRATION_SCOPE_OPTIONS = ["gmail", "fireflies", "zoom", "clickup", "telegram", "gohighlevel", "cross"] as const;

export type IntegrationScope = (typeof INTEGRATION_SCOPE_OPTIONS)[number];
